// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"c03bc2ee","293":"eee0319f","325":"92dd3c41","495":"d61d5014","496":"062e2ddf","563":"8b14852f","589":"004b354b","648":"4277f2b9","747":"41e8421e","749":"e31edc57","791":"7ff6dd3d","793":"e660d9ec","976":"a11c6d88"}[chunkId] + ".chunk.js";
};